import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

export async function deleteSurvey(id) {
  const url = SURVEY_ENDPOINTS.DELETE.replace(':id', id)
  await apiClient('generic-survey').delete(url)
  return { id }
}
